import { useEffect, useRef, useState } from 'react';
import { AxiosResponse } from 'axios';
import { useFormik } from 'formik';
import * as Yup from 'yup';

import { ModelOfCreditor } from 'src/database/index';

import { useAuth } from 'src/contexts/auth';
import api from 'src/services/api';

interface CreditorCpfProps {
  NOME: string;
  DATANASCIMENTO: string;
}

export const useFormCreateCreditor = () => {
  const { userAgencyId } = useAuth();
  const [loading, setLoading] = useState(false);
  const [CreditorCpf, setCreditorCpf] = useState<CreditorCpfProps[]>([{ NOME: '', DATANASCIMENTO: '' }]);
  const [loadingCreditorCpf, setLoadingCreditorCpf] = useState(false);
  const [foundCreditorCpf, setFoundCreditorCpf] = useState(false);
  const [creditorResponse, setCreditorResponse] = useState<AxiosResponse | null>(null);
  const [creditorEditedResponse, setCreditorEditedResponse] = useState<AxiosResponse | null>(null);

  const toast: any = useRef();

  const validationSchema = Yup.object().shape({
    NOME: Yup.string().required('* Campo obrigatório'),
    BANCO: Yup.string().required('* Campo obrigatório'),
    CPF_CNPJ: Yup.string().required('* Campo obrigatório'),
    AGENCIA: Yup.string().required('* Campo obrigatório'),
    CONTA: Yup.string().required('* Campo obrigatório'),
  });

  const saveCreditor = (Creditor: ModelOfCreditor) => {
    setLoading(true);

    const newCreditor: ModelOfCreditor = {
      ...Creditor,
      ORGAO: userAgencyId,
    };

    if (!!creditorResponse) {
      api.put(`creditors/${creditorResponse.data.ID}`, newCreditor)
        .then((response) => {
          formik.resetForm();
          setCreditorEditedResponse(response);
          setCreditorResponse(null);
          setLoading(false);
          toast.current.show({ severity: 'success', summary: 'Edição realizada', detail: 'O credor foi editado com sucesso!', life: 5000 });
        }).catch((err) => {
          console.log(err);
          setLoading(false);
          toast.current.show({ severity: 'error', summary: 'Edição não realizado', detail: 'Falha ao realizar operação!', life: 5000 });
        })
    } else {
      console.log("newCreditor:", newCreditor)
      api.post('/creditors', newCreditor)
        .then((response) => {
          setCreditorResponse(response);
          setCreditorEditedResponse(null);
          setLoading(false);
          toast.current.show({ severity: 'success', summary: 'Cadastro realizado', detail: 'Operação realizada com sucesso!', life: 5000 });
        }).catch((err) => {
          console.log(err);
          setLoading(false);
          toast.current.show({ severity: 'error', summary: 'Cadastro não realizado', detail: 'Falha ao realizar operação!', life: 5000 });
        });
    }
  };

  const formik = useFormik<ModelOfCreditor>({
    initialValues: {
      NOME: '',
      CPF_CNPJ: '',
      ORGAO: '',
      BANCO: '',
      AGENCIA: '',
      CONTA: '',
      PESSOA: '',
    },
    onSubmit: async values => await saveCreditor(values),
    validationSchema
  });

  const searchCreditorCpf = async (cpf: string) => {
    setLoadingCreditorCpf(true);
    const response = await api.post('people/get-person', { CPF: cpf });
    setCreditorCpf(response.data);
    setFoundCreditorCpf(!!response.data[0]);
    setLoadingCreditorCpf(false);
  };

  useEffect(() => {
    if (foundCreditorCpf) {
      formik.setFieldValue('NOME', CreditorCpf[0].NOME);
    }
  }, [foundCreditorCpf]);

  return {
    getCreditorFormController: {
      formik,
      loading,
      loadingCreditorCpf,
      foundCreditorCpf,
      CreditorCpf,
      toast,
      creditorResponse,
      creditorEditedResponse
    },
    handleCreditorFormController: {
      searchCreditorCpf,
      setFoundCreditorCpf,
      setCreditorResponse,
      setCreditorEditedResponse
    }
  };
};